<template>
  <div class="newsdetails">
    <!-- <div class="trends">
      <p style="font-size: 46px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #FFFFFF;">资讯动态</p>
      <p style="font-size: 20px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 400;color: #FFFFFF;">关注企业最新资讯</p>
    </div> -->
    <div class="back" @click="back">&lt;&nbsp;返回</div>
    <div class="newsMain" style="margin-top: .625rem;">
        <p class="newsTitle">{{ detailsData.consultName }}</p>
        <div class="seeTime">
            <!-- <span style="font-size: 14px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;"></span> -->
            <span style="font-size: .175rem;font-family: Source Han Sans CN, Source Han Sans C v  N;font-weight: 500;color: #A2A2A2;margin-top: .125rem">{{ detailsData.createTime }}</span>
        </div>
        <!-- <div class="newsImg" style="height: 3.5625rem;margin-top: .375rem;">
            <img :src="detailsData.consultImg" alt="" style="width: 100%;height: 100%;">
        </div> -->
        <div class="newsContent" v-html="detailsData.consultContent"></div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter,useRoute } from 'vue-router';
import { consultDetails } from "@/api/home.js"
const router = useRouter()
const route = useRoute();

const countId = ref("")
const detailsData = ref({})
onMounted(()=> {
  countId.value = route.query.consultId
  getDetails(countId.value)
})
const getDetails = (countId) => {
  consultDetails(countId).then(res=> {
    detailsData.value = res.data.data
    detailsData.value.consultContent =  detailsData.value.consultContent.replaceAll('<img', '<img style="vertical-align: top;margin-top:.25rem;margin-bottom:.25rem;height:4.75rem;display:block;margin-left:auto;margin-right:auto;"')
  })
}

const back = () => {
    router.go(-1)
}
</script>

<style scoped>

.back {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    text-align: left;
    margin-left: .425rem;
    margin-top: 1.625rem;
    padding-left: 4.125rem;
    cursor: pointer;
}
.trends {
  height: 3.5rem;
  background: url("../../../assets/img/news_bg.png") no-repeat;
  background-size: 100% 100%;
  text-align: left;
  padding-left: 4.5rem;
  padding-top: 1.175rem;
}
.newsMain {
    margin: .7375rem 4.5rem;
    /* background: pink; */
}
.newsTitle {
    font-size: .425rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    text-align: left;
}
.seeTime {
    display:flex;
}
.newsContent {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    margin-top: .125rem;
    /* line-height: .35rem; */
    text-align: left;
    text-indent: 2em;
}

.newsContent img {
  width: 100%; /* 设置图片宽度 */
  height: auto; /* 设置图片高度 */
  /* 其他图片样式 */
}

</style>
